
export function setVoiceCallInfo(info) {

    return {
        type: 'voiceCallInfo',
        payload: info
    }
}